import { inlineDownloadCampaignODataPlugin } from './campaign-odata-plugin';
import { withoutFilterState, withoutSegment } from './without-dependencies';

export const inlineDownloadWithoutFilterstatePlugin =
  withoutFilterState(inlineDownloadCampaignODataPlugin);

export const inlineDownloadWithoutSegmentPlugin =
  withoutSegment(inlineDownloadCampaignODataPlugin);

export const inlineDownloadWithoutFilterstateAndSegmentPlugin =
  withoutFilterState(withoutSegment(inlineDownloadCampaignODataPlugin));
